import { render, staticRenderFns } from "./PrestacionSaludProgramas.vue?vue&type=template&id=75267cf2&scoped=true"
import script from "./PrestacionSaludProgramas.vue?vue&type=script&lang=ts"
export * from "./PrestacionSaludProgramas.vue?vue&type=script&lang=ts"
import style0 from "./PrestacionSaludProgramas.vue?vue&type=style&index=0&id=75267cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75267cf2",
  null
  
)

export default component.exports